import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export const Card = ({ children, className }: CardProps) => (
  <div className={cn('bg-surface rounded-card border border-line shadow-card', className)}>{children}</div>
);

interface CardHeaderProps {
  children?: ReactNode;
  className?: string;
  /** Title on the left. Use with `action` for the common "title left, action/meta right" row. */
  title?: ReactNode;
  /** Action or meta on the right. */
  action?: ReactNode;
}

export const CardHeader = ({ children, className, title, action }: CardHeaderProps) => (
  <div className={cn('px-4 sm:px-6 py-4 border-b border-line', className)}>
    {title !== undefined || action !== undefined ? (
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-card font-semibold text-ink">{title}</h3>
        {action && <div className="flex items-center gap-2 text-label text-muted">{action}</div>}
      </div>
    ) : (
      children
    )}
  </div>
);

export const CardBody = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={cn('px-4 sm:px-6 py-4', className)}>{children}</div>
);

export const CardFooter = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={cn('px-4 sm:px-6 py-4 border-t border-line bg-page rounded-b-card', className)}>{children}</div>
);
